import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  Button,
  DialogActions,
  DialogTitle,
  DialogContent,
  TextField,
  Grid,
  Typography
} from "@material-ui/core/";
import { DatePicker, MuiPickersUtilsProvider, TimePicker } from "material-ui-pickers";
import MomentUtils from "@date-io/moment";
import "moment/locale/es";
import moment from 'moment'

export class EventDialog extends React.Component {
  static HOUR = 3600000;
  constructor(props) {
    super(props);
    this.initialState = EventDialog.getStateFromProps(props);
    this.state = { ...this.initialState, gapi_loaded: false };
  }

  static getStateFromProps(props) {
    const { summary, description, start, end, location } = props.event.data;
    let startDate = new Date(Date.parse(start.dateTime));
    if (isNaN(startDate)){
      startDate = (moment().add(1, 'hours'))._d;
    }

    let endDate = new Date(Date.parse(end.dateTime));
    if (isNaN(endDate))
      endDate = new Date(startDate.getTime() + 1 * EventDialog.HOUR);
    const date = moment(startDate).format('YYYY-MM-DD');
    const hours = moment(startDate).format("HH:mm");
    const duration = (((moment(endDate)).diff((moment(startDate)), 'minutes')) / 60).toFixed(1);
    let fullDate = startDate;

    return {
      fullDate,
      summary,
      location,
      description,
      date: date,
      time: hours,
      duration
    };
  }

  disabledSave = () => {
    const { summary, description, date, time, location } = this.state;
    return (
      this.props.disabled ||
      summary === "" ||
      description === "" ||
      date === "1" ||
      time === "1" ||
      location === ""
    );
  };

  validfield = (field) => {
    return (this.state[field] === "");
  }

  onChangeSummary = e => {
    this.setState({ summary: e.target.value });
  };

  onCancel = e => {
    const EventStartDate = moment(this.props.event.data.start.dateTime);
    let genericDate = (moment().add(1, 'hours'))._d;
    if ((EventStartDate._d).toString() !== 'Invalid Date') {
        genericDate = EventStartDate._d;
    }
    this.setState({ ...this.initialState, fullDate: genericDate });
    this.props.onClose();
  };

  onChangeDescription = e => {
    this.setState({ description: e.target.value });
  };

  onChangeLocation = e => {
    this.setState({ location: e.target.value });
  };

  onChangeDuration = e => {
    const value = parseFloat(e.target.value).toFixed(1);
    this.setState({ duration: value });
  };

  onChangeDate = date => {
    const nextDate= date._d;
    const currentDocDate = this.state.fullDate;
    const year = moment(nextDate).format('YYYY');
    const month = moment(nextDate).format('MM') - 1;
    const day = moment(nextDate).format('DD');
    currentDocDate.setFullYear(year, month, day);
    this.setState({
       date: date.format('YYYY-MM-DD'),
       fullDate: currentDocDate
     });
  };

  onChangeTime = time => {
    let date = time._i;
    date.setHours(moment(time).format("HH"));
    date.setMinutes(moment(time).format("mm"));
    this.setState({ time: moment(time).format("HH:mm")});
  };

  onEventSave = () => {
    const { summary, description, date, time, duration, location } = this.state;
    const startDateTime = new Date(Date.parse(date + " " + time));
    const endDateTime = new Date(
      startDateTime.getTime() + duration * EventDialog.HOUR
    );
    const data = {
      summary,
      location,
      description,
      start: {
        dateTime: startDateTime.toISOString(),
        timeZone: "America/Chihuahua"
      },
      end: {
        dateTime: endDateTime.toISOString(),
        timeZone: "America/Chihuahua"
      }
    };
    this.props.onEventSave({ ...this.props.event, data });
    this.props.onClose();
  };

  render() {
    const { open, disabled } = this.props;
    const { summary, description, date, duration, location, fullDate } = this.state;
    return (
      <Dialog
        onClose={this.onCancel}
        aria-labelledby="create-event"
        open={open}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{disabled? 'Detalles del evento' : 'Agendar evento'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={8}>
            <Grid item sm={12} md={12} lg={12} xs={12}>
              <TextField
                value={summary}
                onChange={this.onChangeSummary}
                disabled={disabled}
                label="Título"
                fullWidth
                error={this.validfield('summary')}
                required
              />
            </Grid>
            <Grid item sm={12} md={12} lg={12} xs={12}>
              <TextField
                value={description}
                onChange={this.onChangeDescription}
                disabled={disabled}
                label="Descripción"
                fullWidth
                error={this.validfield('description')}
                required
              />
            </Grid>
            <Grid item sm={12} md={12} lg={12} xs={12}>
              <TextField
                value={location}
                onChange={this.onChangeLocation}
                disabled={disabled}
                label="Lugar"
                fullWidth
                error={this.validfield('location')}
                required
              />
            </Grid>
            <Grid item sm={12} md={4} lg={4} xs={12}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  value={date}
                  disabled={disabled}
                  label="Fecha"
                  autoOk
                  disablePast={disabled? false : true}
                  onChange={date => this.onChangeDate(date)}
                  format="L"
                  okLabel='Aceptar'
                  cancelLabel='Cancelar'
                  minDateMessage='Fecha no válida'
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item sm={12} md={4} lg={4} xs={12}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <TimePicker
                  value={fullDate}
                  onChange={time => this.onChangeTime(time)}
                  disabled={disabled}
                  label="Hora"
                  okLabel='Aceptar'
                  cancelLabel='Cancelar'
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item sm={12} md={3} lg={3} xs={12}>
              <TextField
                type="number"
                value={duration}
                onChange={this.onChangeDuration}
                disabled={disabled}
                label="Duración (Horas)"
                inputProps={{ step: "0.5" }}
              />
            </Grid>
            <Grid item sm={12} md={12} lg={12} xs={12}>
              <Typography align="left" variant="body2" style={{ color: '#808080'}}>*Campos requeridos</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="button_modal">
          <Button onClick={this.onCancel} color="primary" className="button_modal_medium">
            {disabled? 'Cerrar' : 'Cancelar'}
          </Button>
          {disabled?
            null : (
              <Button
                onClick={this.onEventSave}
                color="primary"
                disabled={this.disabledSave()}
                className="button_modal_medium"
              >
                Guardar
              </Button>
            )
          }
        </DialogActions>
      </Dialog>
    );
  }
}

EventDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onEventSave: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/components/EventDialog.js